module.exports = __webpack_public_path__ + "static/media/lease2_img11.88561b84.jpg";